import { MenuItem } from '@chakra-ui/react';
import { useAttachmentContext } from './AttachmentProvider';

const AttachmentMenuItem = () => {
  const { openFilePicker } = useAttachmentContext();

  return <MenuItem onClick={openFilePicker}>Add Attachment</MenuItem>;
};

export default AttachmentMenuItem;